import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, Glyphicon, Modal, Table} from 'react-bootstrap';
import TablePager from '../TablePager';

class AttachmentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      attachments: [],
    };

    this.fileInput = React.createRef();
  }

  onFileChange = (event) => {
    let files = event.target.files;

    if (event.nativeEvent.file) {
      const { name, type, data } = event.nativeEvent.file;

      files = { 1: new File([data], name, { type }) };
    }

    this.setState({ attachments: Object.values(files) });
  };

  onHide = () => {
    this.setState({ attachments: [] });
    this.fileInput.value = '';
    this.props.onHide();
  };

  upload = (event) => {
    event.preventDefault();
    if (this.state.attachments.length > 0) {
      this.props.uploadFiles(this.state.attachments);
      this.setState({ attachments: [] });
      this.fileInput.value = '';
    }
  };

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Attachments
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form horizontal onSubmit={this.upload}>
            <FormGroup className='flex-row'>
              <Col xs={2} style={{ textAlign: 'left', paddingRight: 0 }} componentClass={ControlLabel}>
                Upload:
              </Col>
              <Col xs={7} style={{ paddingLeft: 0 }}>
                <FormControl data-cy='upload-input' inputRef={(ref) => this.fileInput = ref} type='file' multiple onChange={this.onFileChange}/>
              </Col>
              <Col xs={3} className='ta-right'>
                <Button data-cy='upload-button' type='submit'>Upload</Button>
              </Col>
            </FormGroup>
          </Form>
          <br/>
          <TablePager data={this.props.files} dataTable={(files, offset) =>
            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Filename</th>
                  <th>Uploaded by</th>
                  <th/>
                </tr>
              </thead>
              <tbody data-cy='attachment-table'>
              {
                files.map((file, i) => {
                  return (
                    <tr key={i}>
                      <td>{offset+i+1}.</td>
                      <td>{file.file_name}</td>
                      <td>{file.user_name}</td>
                      <td style={{minWidth: '85px'}}>
                        <a data-cy='attachment-link' href={file.url}><Glyphicon glyph='download-alt'/></a>
                        <a data-cy='delete-attachment' className='ml1 cursor-ptr' onClick={() => this.props.deleteFile(file)}><Glyphicon glyph='trash'/></a>
                      </td>
                    </tr>
                  );
                })
              }
              </tbody>
            </Table>
          }/>
        </Modal.Body>
      </Modal>
    );
  }
}

AttachmentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  uploadFiles: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
};

export default AttachmentModal;



// WEBPACK FOOTER //
// ./src/components/engagement/AttachmentModal.js